import React from 'react'
import {
  Div,
  Flex,
  Icon as QDSIcon,
  Text,
} from '@sendoutcards/quantum-design-ui'

import {
  DuvetHandle,
  DuvetHandleDirection,
} from './components/DuvetHandle/DuvetHandle'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { IconType } from 'src/design_system/atoms/icons/types'
import { motion } from 'framer-motion'

type FakeDuvetV2Props = {
  openValue: number
  isOpen: boolean
  headerOffset?: string
  shouldShowCloseButton?: boolean
  title?: string
  titleIcon?: IconType
  handleDirection?: DuvetHandleDirection
  onClose?: () => void
  children: React.ReactNode
}

export const FakeDuvetV2 = (props: FakeDuvetV2Props) => {
  const {
    children,
    isOpen,
    openValue,
    headerOffset,
    title,
    titleIcon,
    onClose,
  } = props

  return (
    <>
      {isOpen && (
        <Div
          boxShadow="0px 8px 16px 0px rgb(0 0 0 / 10%);"
          borderRadius={{ top: 'large' }}
          key="duvet"
          width={'100%'}
          height={`${openValue}px`}
          backgroundColor={'foreground'}
          position="fixed"
          bottom="0px"
          overflow="hidden"
          data-should-drag="true"
          dragListener={false}
          zIndex={8}
        >
          <motion.div
            style={{
              touchAction: 'none',
              position: 'relative',
              top: '0px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              zIndex: 1,
              padding: '24px 16px 8px 16px',
            }}
          >
            <DuvetHandle />
            {title && titleIcon && (
              <Flex
                justifyContent="space-between"
                width="100%"
                inset={{ horizontal: 'x1', top: 'x_5' }}
              >
                <Div>
                  <Flex flexDirection="row" columnGap="x1" alignItems="center">
                    <Icon name={titleIcon} size={23} fill="#000" />
                    <Text
                      type="largeBody"
                      weight="semiBold"
                      color="primaryHeading"
                      style={{ fontSize: '16px' }}
                    >
                      {title}
                    </Text>
                  </Flex>
                </Div>
                <Flex
                  onClick={onClose}
                  justifyContent="center"
                  alignItems="center"
                  backgroundColor="#F5F5F5"
                  borderRadius="circle"
                  inset=".5rem"
                  zIndex={2}
                >
                  <QDSIcon
                    name="close"
                    size={14}
                    primaryColor="primaryBodyText"
                  />
                </Flex>
              </Flex>
            )}
          </motion.div>
          <Div
            top={headerOffset}
            left="0px"
            inset={{ horizontal: 'x2' }}
            width="100%"
            overflow="hidden"
            data-should-drag="true"
          >
            {children}
          </Div>
        </Div>
      )}
    </>
  )
}
